module.exports = __webpack_public_path__ + "static/media/collaboration-coffee-people.371b292b.jpg";